
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/piano-removal",
      function () {
        return require("private-next-pages/piano-removal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/piano-removal"])
      });
    }
  